// ============================================================================
// GumaHUB useAuth Hook
// ============================================================================

import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext.js';
import type { AuthContextType } from '../types/index.js';

export function useAuth(): AuthContextType {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
}

export default useAuth;
